import { render, staticRenderFns } from "./modalImportar.vue?vue&type=template&id=624eea23&"
import script from "./modalImportar.vue?vue&type=script&lang=js&"
export * from "./modalImportar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports